import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateGradeLevelForm from "../../forms/CreateOrUpdateGradeLevelForm";
import { GradeLevelResponseDto } from "../../shared/dtos/gradeLevel/GradeLevelResponseDto";

interface UpdateGradeLevelModalProps {
  open: boolean;
  onClose: () => void;
  gradeLevel: GradeLevelResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateGradeLevelModal: React.FC<UpdateGradeLevelModalProps> = ({
  open,
  onClose,
  gradeLevel,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${gradeLevel.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateGradeLevelForm
      isEditing={true}
      gradeLevel={gradeLevel}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateGradeLevelModal;
